import { AllergenHighlightKind } from "./allergenhighlightkind";
import { FibreBasis } from "./fibrebasis";
import { IngredientDeclarationQuidRoundingKind } from "./ingredientdeclarationquidroundingkind";
import { IngredientDeclarationDisplayKind } from "./ingredientdeclarationdisplaykind";
import { BopRounding } from "./BopRounding";

class UserSettings {
    public ingredientDeclarationQuidRoundingKind: IngredientDeclarationQuidRoundingKind;
    public ingredientDeclarationDisplayKind: IngredientDeclarationDisplayKind;
    public allergenHighlightKind: AllergenHighlightKind;
    public fibreBasis: FibreBasis;
    public showDemoRecipes: boolean;
    public recipeNamesUppercase: boolean;
    public ingredientNamesUppercase: boolean;   
    public searchResultsSize: number;
    public hongKongServingSetting: number;
    public recentRecipes: string;
    public recentIngredients: string;
    public lastNotificationId: number;
    public copyToClipboardExcelFormat: string;
    public resultListViewStyle: number;
    public reportsListViewStyle: number;
    public searchOptions: string;
    public hasExistingUserSettings: boolean;
    public alternativeBOPRounding: BopRounding;
    public externalAccessKey: string;
    public currencyCode: number;
    public useCurrencySymbol: boolean;
    public currencySymbol: string;
    public ccyCode: string;
    public traceGainsOptIn: boolean;
    public marketingOptIn: boolean;
}

export { UserSettings };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/Models/usersettings.ts